import Axios from "axios";
import { ApiBaseUrl, CartableBaseUrl } from "../config/config";
import { CartableNotification } from "../models/cartableModel";
import { ApiResultModel } from "../models/common.model";
import {
  Filter,
  GetLoanDetailResponse,
  GetLoansRequest,
} from "../models/loan.model";

export const GetCartableNotification = (): Promise<CartableNotification> => {
  return Axios.post<ApiResultModel<CartableNotification>>(
    ApiBaseUrl + CartableBaseUrl + "/GetCartableNotification"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetRegisterLoans = (
  data: GetLoansRequest
): Promise<ApiResultModel<GetLoanDetailResponse[]>> => {
  return Axios.post<ApiResultModel<GetLoanDetailResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetRegisterLoans",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetLoansForSettlement = (
  data: GetLoansRequest
): Promise<ApiResultModel<GetLoanDetailResponse[]>> => {
  return Axios.post<ApiResultModel<GetLoanDetailResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetLoansForSettlement",
    data
  ).then((result) => {
    return result.data;
  });
};

export const ExportGetRegisterLoans = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + CartableBaseUrl + "/ExportGetRegisterLoans",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` ثبت نام توسط پذیرنده.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const ExportLoansForSettlement = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + CartableBaseUrl + "/ExportLoansForSettlement",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `لیست تسهیلات.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const getLoansForSettlement = (
  data: GetLoansRequest
): Promise<ApiResultModel<GetLoanDetailResponse[]>> => {
  return Axios.post<ApiResultModel<GetLoanDetailResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetLoansForSettlement",
    data
  ).then((result) => {
    return result.data;
  });
};
export const exportLoansForSettlement = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + CartableBaseUrl + "/ExportLoansForSettlement",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` تسویه با پذیرنده.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
